import { takeLatest } from "redux-saga/effects";
import CONSTANTS from "../../util/constants";
import { getContainers } from "./ContainersSaga";
import { createCorrection, getCorrectionsLog } from "./CorrectionSaga";
import {
  createDepartment,
  deleteDepartment,
  editDepartment,
  getDepartments,
} from "./DepartmentSaga";
import {
  createDivisions,
  editDivisions,
  getDivisionByID,
  getDivisions,
} from "./DivisionSaga";
import {
  createDoors,
  editDoors,
  getDoors,
  getDoorsById,
  getDoorsLog,
} from "./DoorsSaga";
import { createDriver, editDriver, getDriver } from "./DriverSaga";
import { createLocation, editLocation, getLocation } from "./LocationSaga";
import {
  callConfirmPasswordAPI,
  callForgotPasswordAPI,
  callGetDivisionStats,
  callLoginAPI,
  updateLoginAPI,
} from "./LoginSaga";
import {
  createLots,
  editLots,
  getLots,
  getLotsWithDivision,
  getSpaceForLots,
  getSpaceLogs,
} from "./LotsSaga";
import {
  createContainer,
  createMove,
  deleteMove,
  getDoorForMove,
  getMove,
  getMoveByTypes,
  getSpaceFrom,
  getSpaceTo,
  updateMove,
} from "./MoveSaga";
import { getNotification, updateNotification } from "./NotificationSaga";
import { createOffSite, getOffSite } from "./OffsiteSaga";
import { getTrailers, getTrailersLog } from "./RuralTrailersSaga";
import {
  createTrailerManagement,
  editTrailerManagement,
  getTrailerManagement,
} from "./TrailerManagementSaga";
import { createTruck, editTruck, getTruck } from "./TruckSaga";
import {
  addUserRole,
  createUserManagement,
  editUserManagement,
  getAllUserRolesFunc,
  getUserManagement,
  getActiveUserManagement,
} from "./UserManagementSaga";
import {
  createReports,
  divisionBulk,
  doorBulk,
  getDoorCheckWorkSheet,
  getLotCheckWorkSheet,
  lotsBulk,
  spacesBulk,
  trailerBulk,
  updatePDFData,
  userBulk,
} from "./WorkSheetSaga";

function* rootSaga() {
  yield takeLatest(CONSTANTS.CONSTANTS_LOGIN.CALL_LOGIN_API, callLoginAPI);
  yield takeLatest(
    CONSTANTS.CONSTANTS_LOGIN.UPDATE_LOGIN_RESPONSE,
    updateLoginAPI
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_LOGIN.LOGIN_FORGOT_PASSWORD_API_CALL,
    callForgotPasswordAPI
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_LOGIN.LOGIN_CONFIRM_PASSWORD_API_CALL,
    callConfirmPasswordAPI
  );

  yield takeLatest(
    CONSTANTS.CONSTANTS_TRAILER_MANAGEMENT.GET_TRAILER_MANAGEMENT_API_CALL,
    getTrailerManagement
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_TRAILER_MANAGEMENT.EDIT_TRAILER_MANAGEMENT_API_CALL,
    editTrailerManagement
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_TRAILER_MANAGEMENT.ADD_TRAILER_MANAGEMENT_API_CALL,
    createTrailerManagement
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_USER_MANAGEMENT.GET_USER_MANAGEMENT_API_CALL,
    getUserManagement
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_USER_MANAGEMENT.GET_ACTIVE_USER_MANAGEMENT_API_CALL,
    getActiveUserManagement
  );

  yield takeLatest(
    CONSTANTS.CONSTANTS_USER_MANAGEMENT.EDIT_USER_MANAGEMENT_API_CALL,
    editUserManagement
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_USER_MANAGEMENT.ADD_USER_MANAGEMENT_API_CALL,
    createUserManagement
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_USER_MANAGEMENT.ADD_USER_ROLES_MANAGEMENT_API_CALL,
    addUserRole
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_USER_MANAGEMENT.GET_USER_ROLES_MANAGEMENT_API_CALL,
    getAllUserRolesFunc
  );

  yield takeLatest(
    CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.GET_DOORS_MANAGEMENT_API_CALL,
    getDoors
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.ADD_DOORS_MANAGEMENT_API_CALL,
    createDoors
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.EDIT_DOORS_MANAGEMENT_API_CALL,
    editDoors
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.GET_DOORSBYID_MANAGEMENT_API_CALL,
    getDoorsById
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.GET_DOORS_FOR_MOVE_MANAGEMENT_API_CALL,
    getDoorForMove
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.GET_DOORS_LOG_MANAGEMENT_API_CALL,
    getDoorsLog
  );

  yield takeLatest(
    CONSTANTS.CONSTANTS_DIVISIONS_MANAGEMENT
      .GET_DIVISIONSBYID_MANAGEMENT_API_CALL,
    getDivisionByID
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_DIVISIONS_MANAGEMENT.GET_DIVISIONS_MANAGEMENT_API_CALL,
    getDivisions
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_DIVISIONS_MANAGEMENT.ADD_DIVISIONS_MANAGEMENT_API_CALL,
    createDivisions
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_DIVISIONS_MANAGEMENT.EDIT_DIVISIONS_MANAGEMENT_API_CALL,
    editDivisions
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_LOGIN.GET_USER_DIVISION_STATS_CALL,
    callGetDivisionStats
  );

  yield takeLatest(
    CONSTANTS.CONSTANTS_LOTS_MANAGEMENT.GET_LOTS_MANAGEMENT_API_CALL,
    getLots
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_LOTS_MANAGEMENT.ADD_LOTS_MANAGEMENT_API_CALL,
    createLots
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_LOTS_MANAGEMENT.EDIT_LOTS_MANAGEMENT_API_CALL,
    editLots
  );

  yield takeLatest(
    CONSTANTS.CONSTANTS_LOTS_MANAGEMENT.GET_LOTS_DIVISION_MANAGEMENT_API_CALL,
    getLotsWithDivision
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_LOTS_MANAGEMENT.GET_SPACES_BY_LOTID_MANAGEMENT_API_CALL,
    getSpaceForLots
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_LOTS_MANAGEMENT.GET_SPACELOGS_MANAGEMENT_API_CALL,
    getSpaceLogs
  );

  yield takeLatest(
    CONSTANTS.CONSTANTS_TRUCK_MANAGEMENT.GET_TRUCK_MANAGEMENT_API_CALL,
    getTruck
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_TRUCK_MANAGEMENT.ADD_TRUCK_MANAGEMENT_API_CALL,
    createTruck
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_TRUCK_MANAGEMENT.EDIT_TRUCK_MANAGEMENT_API_CALL,
    editTruck
  );

  yield takeLatest(
    CONSTANTS.CONSTANTS_DRIVER_MANAGEMENT.GET_DRIVER_MANAGEMENT_API_CALL,
    getDriver
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_DRIVER_MANAGEMENT.ADD_DRIVER_MANAGEMENT_API_CALL,
    createDriver
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_DRIVER_MANAGEMENT.EDIT_DRIVER_MANAGEMENT_API_CALL,
    editDriver
  );

  yield takeLatest(
    CONSTANTS.CONSTANTS_OFFSITE_MANAGEMENT.ADD_OFFSITE_API_CALL,
    createOffSite
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_OFFSITE_MANAGEMENT.GET_OFFSITE_DATA_API_CALL,
    getOffSite
  );

  yield takeLatest(
    CONSTANTS.CONSTANTS_LOCATION_MANAGEMENT.GET_LOCATION_API_CALL,
    getLocation
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_LOCATION_MANAGEMENT.ADD_LOCATION_API_CALL,
    createLocation
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_LOCATION_MANAGEMENT.EDIT_LOCATION_API_CALL,
    editLocation
  );

  yield takeLatest(
    CONSTANTS.CONSTANTS_CORRECTION_MANAGEMENT.ADD_COORECTION_API_CALL,
    createCorrection
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_CORRECTION_MANAGEMENT.GET_CORRECTION_LOG_API_CALL,
    getCorrectionsLog
  );

  yield takeLatest(
    CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.ADD_MOVES_API_CALL,
    createMove
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_MOVES_API_CALL,
    getMove
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_MOVES_BY_TYPES_API_CALL,
    getMoveByTypes
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.DELETE_MOVES_API_CALL,
    deleteMove
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.UPDATE_MOVES_API_CALL,
    updateMove
  );

  yield takeLatest(
    CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_CONTAINERS_API_CALL,
    getContainers
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.CREATE_CONTAINER_API_CALL,
    createContainer
  );

  yield takeLatest(
    CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_DOOR_FOR_MOVES_API_CALL,
    getDoorForMove
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_SPACE_FROM_API_CALL,
    getSpaceFrom
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_SPACE_TO_API_CALL,
    getSpaceTo
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_RURAL_TRAILERS_MANAGEMENT
      .GET_RURAL_TRAILER_MANAGEMENT_API_CALL,
    getTrailers
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_RURAL_TRAILERS_MANAGEMENT
      .GET_RURAL_TRAILER_LOGS_API_CALL,
    getTrailersLog
  );

  yield takeLatest(
    CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.GET_DOOR_CHECK_WORKSHEET_API_CALL,
    getDoorCheckWorkSheet
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.UPDATE_PDF_DATA,
    updatePDFData
  );

  yield takeLatest(
    CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.GET_LOT_CHECK_WORKSHEET_API_CALL,
    getLotCheckWorkSheet
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.DOOR_BULK_API_CALL,
    doorBulk
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.LOTS_BULK_API_CALL,
    lotsBulk
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.SPACE_BULK_API_CALL,
    spacesBulk
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.DIVISION_BULK_API_CALL,
    divisionBulk
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.USER_BULK_API_CALL,
    userBulk
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.TRAILER_BULK_API_CALL,
    trailerBulk
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.CREATE_REPORTS_API_CALL,
    createReports
  );

  yield takeLatest(
    CONSTANTS.CONSTANTS_DEPARTMENT_MANAGEMENT.GET_DEPARTMENT_API_CALL,
    getDepartments
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_DEPARTMENT_MANAGEMENT.ADD_DEPARTMENT_API_CALL,
    createDepartment
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_DEPARTMENT_MANAGEMENT.EDIT_DEPARTMENT_API_CALL,
    editDepartment
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_DEPARTMENT_MANAGEMENT.DELETE_DEPARTMENT_API_CALL,
    deleteDepartment
  );

  yield takeLatest(
    CONSTANTS.CONSTANTS_NOTIFICATIONS_MANAGEMENT.GET_NOTIFICATIONS_API_CALL,
    getNotification
  );
  yield takeLatest(
    CONSTANTS.CONSTANTS_NOTIFICATIONS_MANAGEMENT.EDIT_NOTIFICATIONS_API_CALL,
    updateNotification
  );
}

export default rootSaga;
